import React from 'react';

/**
 * Transient status for sync actions.
 *
 * These used to render as bare colored paragraphs between the toolbar and the
 * Portfolios panel, so every sync pushed the whole dashboard down a line and
 * left "Resynced 1 broker · 16 trades." sitting there indefinitely. Floating
 * them keeps the layout still and lets the confirmation retire on its own.
 *
 * Success auto-dismisses (handled by the caller); errors never do — a failed
 * sync is something the user has to act on, so it stays until dismissed.
 */

function IconCheck() {
  return (
    <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false">
      <path
        d="M13.5 4.5 6.5 11.5 2.5 7.5"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

function IconAlert() {
  return (
    <svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true" focusable="false">
      <path
        d="M8 1.8 15 14H1L8 1.8Z"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinejoin="round"
      />
      <path d="M8 6.4v3.1" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <circle cx="8" cy="11.7" r="0.9" fill="currentColor" />
    </svg>
  );
}

export default function ClientReportingToasts({ notice, error, onDismissNotice, onDismissError }) {
  if (!notice && !error) return null;

  return (
    <div className="vd-cr-toasts">
      {notice ? (
        <div className="vd-cr-toast is-success" role="status" aria-live="polite">
          <span className="vd-cr-toast-icon"><IconCheck /></span>
          <span className="vd-cr-toast-text">{notice}</span>
          <button
            type="button"
            className="vd-cr-toast-close"
            onClick={onDismissNotice}
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      ) : null}

      {error ? (
        <div className="vd-cr-toast is-error" role="alert">
          <span className="vd-cr-toast-icon"><IconAlert /></span>
          <span className="vd-cr-toast-text">{error}</span>
          <button
            type="button"
            className="vd-cr-toast-close"
            onClick={onDismissError}
            aria-label="Dismiss"
          >
            ×
          </button>
        </div>
      ) : null}
    </div>
  );
}
